import { AdminLoginRequest } from "@/api/models/admin/AdminLoginRequest";
import { CancelablePromise, OpenAPI, Response } from "@/api";
import { request as __request } from "../core/request";
import { AdminResponse } from "@/api/models/admin/AdminResponse";
import { AdminListResponse } from "@/api/models/admin/AdminListResponse";
import { ListRequest } from "@/api/models/ListRequest";
import { AdminAddRequest } from "@/api/models/admin/AdminAddRequest";
import { AdminUpdateRequest } from "@/api/models/admin/AdminUpdateRequest";
import { ToDeleteRequest } from "@/utils/slice";

export class AdminService {
  public static Login(body: AdminLoginRequest): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin/login",
      body: body,
      mediaType: "application/json",
    });
  }

  public static Get(): CancelablePromise<AdminResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin",
    });
  }

  public static GetCode(): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/code",
    });
  }

  public static ListAll(
    body: ListRequest
  ): CancelablePromise<AdminListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/list",
      body: body,
    });
  }

  public static Add(
    body: AdminAddRequest
  ): CancelablePromise<AdminListResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin",
      body: body,
    });
  }

  public static Update(
    body: AdminUpdateRequest
  ): CancelablePromise<AdminListResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin",
      body: body,
    });
  }

  public static Delete(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin",
      body: ToDeleteRequest(body),
    });
  }

  public static Drop(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/drop",
      body: ToDeleteRequest(body),
    });
  }
}
